import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Input } from 'components/fields'
import { Note, CenteredContent, CircleBadge, Title } from 'components/misc'
import { ElevatedButton } from 'components/layout'
import { apiDashboard } from 'helpers/decorators/api'
import { form } from 'helpers/decorators'
import Textarea from '../../../../components/fields/Textarea/Textarea'
import validate from './award-approval-validation'


@apiDashboard.apiAwards()
@form({
  form: 'sendAssessorRequest',
  disableHook: true,
  validate
})
class AwardApproval extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    onSendLeaderRequest: PropTypes.func,
    handleSubmit: PropTypes.func,
    reset: PropTypes.func,
    awardId: PropTypes.number,
    isPersonalReflectionMandatory: PropTypes.bool,
    lastPersonalReflection: PropTypes.string,
    initialize: PropTypes.func
  }

  componentDidMount() {
    this.props.initialize({ personalReflection: this.props.lastPersonalReflection })
  }

  handleSubmit = fields => this.props.onSendLeaderRequest(this.props.awardId, fields, { resetForm: this.props.reset })

  render() {
    const {
      loading,
      handleSubmit
    } = this.props

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <CenteredContent marginAuto>
          <CircleBadge defaultColor large medal>
            <i className='ico ico--icon-victory' />
          </CircleBadge>
        </CenteredContent>

        <Title defaultColor h2 style={{ textAlign: 'center', paddingTop: '10px' }}>
          <FormattedMessage id='moduleTitle.congratulation' defaultMessage='Congratulation!' />
        </Title>
        <Note margin='20px 0 30px'>
          <FormattedMessage
            id='label.you_have_completed_all_sections_of_your_award'
            defaultMessage='You have completed all sections of your Award. You can now submit it to your Award Leader for approval. You can also add a personal note below.'
          />
        </Note>

        <Input name='note' label='Note for leader' intlKey='label.note_for_leader' optional />

        <Textarea name='personalReflection' maxLength={2000} label='Your "personal sketch": Please share and reflections on your Award experiences.' intlKey='label.personal_reflection' optional />
        <ElevatedButton
          uppercase rounded submit padded fullWidth
          isLoading={loading}
          intlKey='button.send_award_for_approval'
        >
          Send Award for approval
        </ElevatedButton>
      </form>
    )
  }
}

export default AwardApproval
